import React from "react";
import { useNavigate } from "react-router-dom";
import star from "../../assets/star.gif" 
import rover from "../../assets/rover.gif"
import gallery from "../../assets/gallery.gif"
import mailbox from "../../assets/mailbox.gif"
import { Navbar, NavItem, NavLogo } from "retro-react";

const MobileHeader = () => {
    const navigate = useNavigate();
        return(
            <Navbar
                color="primary"
                pattern="noise"
                style={{position:"fixed"}}
            >
                <NavItem hidden onClick={() => navigate("/")}>
                <img src={star} alt="Star" className="star-icon" />
                <a>
                    Home
                </a>
                </NavItem>
                <NavItem onClick={() => navigate("about")}> 
                <img src={rover} alt="Star" className="rover-icon" />
                <a>
                    About
                </a>
                </NavItem>
                <NavItem onClick={() => navigate("contact")}>
                <img src={mailbox} alt="Star" className="mail-icon" />
                <a>
                    Contact
                </a>
                </NavItem>
                <NavItem  onClick={() => navigate("gallery")}> 
                <img src={gallery} alt="Star" className="gallery-icon" />
                <a>
                    Gallery
                </a>
                </NavItem>
                <NavLogo/>
            </Navbar>
        );
}

export default MobileHeader;